// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProjectBox-module--wrapper--hD0nr","title":"ProjectBox-module--title--jaJ09","gauge":"ProjectBox-module--gauge--2pgKd","item":"ProjectBox-module--item--188n0"};